import { PermissionsPermissionType as Data } from '@/typings/api/PermissionsPermissionType'
import { Model, createMessages } from '@/helpers/Model'


export class PermissionsPermissionTypeModel extends Model<Data> {
  public static readonly page_title = createMessages({
    create: 'Добавить действие',
    edit: 'Редактировать действие',
    view: (data: PermissionsPermissionTypeModel) => 'Действие «{name}»'
      .replace('{name}', data.name || '...'),
    list: 'Действия',
  });

  public static readonly modal_delete = createMessages({
    delete: (data: PermissionsPermissionTypeModel) => 'Удаление действия «{name}»'
      .replace('{name}', data.name || '...'),
    delete_all: 'Удаление выбранных действий',
    delete_all_partly: 'Удаление части выбранных действий',
  });

  public static readonly response_success = createMessages({
    ...Model.response_success,
    delete_all_deny: 'Выбранные действия нельзя удалить',
  });

  public static readonly response_error = createMessages({
    ...Model.response_error,
  });
}
